import React from 'react';
import { initialState } from './reducer';

export const StoreContext = React.createContext({
  store: initialState,
  dispatch: null,
});

export const StoreContextProvider = StoreContext.Provider;
